import * as React from "react";
import {
  Box,
  Typography,
  Button,
  Divider,
  IconButton,
  FormControl,
  Input,
  InputLabel,
  styled,
} from "@mui/material";
import Header from "../../components/global/Header";
import { getCurrentPlan, changeCurrentPlan } from "../../data/PricingData";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router";

const Container1 = styled(InputLabel)`
  color: aliceblue;

  &.Mui-focused {
    color: var(--white) !important;
  }
`;

const Container2 = styled(Input)`
  color: aliceblue;
`;

const StyledButton = styled(Button)`
  background-color: var(--color-midnightblue);
  color: var(--white);
  margin-top: 20px;

  &:hover {
    background-color: var(--color-midnightblue);
  }
`;

const scrollbarStyles = `
::-webkit-scrollbar {
  width: 15px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: var(--color-dimgray);
}

::-webkit-scrollbar-thumb:hover {
  background-color: var(--color-white-50);
}
`;
function BotLink({ plan, isSubscribe }) {
  const currentPlan = getCurrentPlan();
  const navigate = useNavigate();
  const handleClose = () => {
    navigate(-1);
  };

  const onPlanChange = () => {
    const res = changeCurrentPlan(currentPlan);
    console.log("res", res);
    if (res) {
      navigate("/subscriber/plan/change");
    }
  };
  return (
    <>
      {isSubscribe == true ? (
        <Box m={"2vw"}>
          <Header title={"Manage Subscription"} />

          <Box p={4} margin="auto" backgroundColor="#201939">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                variant="h5"
                color="var(--white)"
                mb={2}
                fontWeight={600}
              >
                Subscription Details
              </Typography>
              <IconButton
                edge="end"
                onClick={handleClose}
                style={{
                  borderRadius: "0.3vw",
                  color: "var(--white)",
                }}
              >
                <CloseIcon />
              </IconButton>
            </div>

            <Typography variant="body1" color="var(--white)" mb={2}>
              Current Plan:
              <span
                style={{ color: "var(--color-white-50)", paddingLeft: "0.4vw" }}
              >
                {currentPlan.title}
              </span>
              <br />
              Plan Amount:
              <span
                style={{ color: "var(--color-white-50)", paddingLeft: "0.4vw" }}
              >
                ${currentPlan.price}
              </span>
            </Typography>

            <Divider style={{ background: "var(--color-white-50)" }} />

            <Typography
              variant="h5"
              color="var(--white)"
              my={2}
              fontWeight={600}
            >
              Bot Link
            </Typography>
            <FormControl fullWidth>
              <Container2
                type="text"
                value={"https://www.mql5.com/en/market/mt5/expert"}
                disabled={true}
              />
            </FormControl>
            <Box mt={4}>
              <Button
                variant="contained"
                sx={{ marginRight: 2 }}
                onClick={() => {
                  navigate("/subscriber/plan/view");
                }}
              >
                View Plan
              </Button>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box m="2vw">
          <Header subTitle="No Access" />
        </Box>
      )}
    </>
  );
}

export default BotLink;
